const typeCampaignName = {
  BANNER_SIMPLE: "بنری ساده",
  BANNER_ALTERNATIVE: "بنری جایگزین",

  BANNER_RETARGETING: "بنری ریتارگتینگ",
  BANNER_RELATED_CONTENT: "بنری هدفمند",

  NATIVE_SIMPLE: "همسان ساده",
  NATIVE_RETARGETING: "همسان ریتارگتینگ",
  NATIVE_RELATED_CONTENT: "همسان هدفمند",

  PUSH_SIMPLE: "پوش ساده",
  PUSH_IMMEDIATE: "پوش فوری",
};

const typeCampaignUrl = () => {
  let data = {};
  data[typeCampaignName.BANNER_SIMPLE] = "/campaigns/banner/simple";
  data[typeCampaignName.NATIVE_SIMPLE] = "/campaigns/native/simple";
  data[typeCampaignName.PUSH_SIMPLE] = "/campaigns/push/simple";
  return data;
};

const typeCampaignUrlManage = () => {
  let data = {};
  data[typeCampaignName.BANNER_SIMPLE] = "/campaigns/manage/banner/simple";
  data[typeCampaignName.NATIVE_SIMPLE] = "/campaigns/manage/native/simple";
  data[typeCampaignName.PUSH_SIMPLE] = "/campaigns/manage/push/simple";
  return data;
};

const typeCampaignUrlManageDelete = () => {
  let data = {};
  data[typeCampaignName.BANNER_SIMPLE] =
    "/campaigns/manage/banner/simple/info-deleted";
  data[typeCampaignName.BANNER_RETARGETING] =
    "/campaigns/manage/banner/retargeting/info-deleted";
  data[typeCampaignName.BANNER_RELATED_CONTENT] =
    "/campaigns/manage/banner/related-content/info-deleted";

  data[typeCampaignName.NATIVE_SIMPLE] =
    "/campaigns/manage/native/simple/info-deleted";
  data[typeCampaignName.NATIVE_RETARGETING] =
    "/campaigns/manage/native/retargeting/info-deleted";
  data[typeCampaignName.NATIVE_RELATED_CONTENT] =
    "/campaigns/manage/native/related-content/info-deleted";

  data[typeCampaignName.PUSH_SIMPLE] =
    "/campaigns/manage/push/simple/info-deleted";
  data[typeCampaignName.PUSH_IMMEDIATE] =
    "/campaigns/manage/push/immediate/info-deleted";
  return data;
};

const typeCampaignApiUrl = () => {
  let data = {};
  data[typeCampaignName.BANNER_SIMPLE] = "/v1/campaign/banner/simple";
  data[typeCampaignName.BANNER_RETARGETING] = "/v1/campaign/banner/retargeting";
  data[typeCampaignName.BANNER_RELATED_CONTENT] =
    "/v1/campaign/banner/related-content";

  data[typeCampaignName.NATIVE_SIMPLE] = "/v1/campaign/native/simple";
  data[typeCampaignName.NATIVE_RETARGETING] = "/v1/campaign/native/retargeting";
  data[typeCampaignName.NATIVE_RELATED_CONTENT] =
    "/v1/campaign/native/related-content";

  data[typeCampaignName.PUSH_SIMPLE] = "/v1/campaign/push/simple";
  data[typeCampaignName.PUSH_IMMEDIATE] = "/v1/campaign/push/immediate";
  return data;
};

const typeCampaignApiUrlManage = () => {
  let data = {};
  data[typeCampaignName.BANNER_SIMPLE] = "/v1/campaign/manage/banner/simple";
  data[typeCampaignName.BANNER_RETARGETING] =
    "/v1/campaign/manage/banner/retargeting";
  data[typeCampaignName.BANNER_RELATED_CONTENT] =
    "/v1/campaign/manage/banner/related-content";

  data[typeCampaignName.NATIVE_SIMPLE] = "/v1/campaign/manage/native/simple";
  data[typeCampaignName.NATIVE_RETARGETING] =
    "/v1/campaign/manage/native/retargeting";
  data[typeCampaignName.NATIVE_RELATED_CONTENT] =
    "/v1/campaign/manage/native/related-content";

  data[typeCampaignName.PUSH_SIMPLE] = "/v1/campaign/manage/push/simple";
  data[typeCampaignName.PUSH_IMMEDIATE] = "/v1/campaign/manage/push/immediate";
  return data;
};

export default {
  typeCampaignName,
  typeCampaignUrl,
  typeCampaignUrlManage,
  typeCampaignApiUrl,
  typeCampaignApiUrlManage,
  typeCampaignUrlManageDelete,
};
